<template>
  <ArticlesList :latest="true"></ArticlesList>
</template>

<script>
import ArticlesList from '@/views/ArticlesList'

export default {
  name: 'LatestNews',
  components: { ArticlesList },
}
</script>
